import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=312ffe44&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ffe44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312ffe44')) {
      api.createRecord('312ffe44', component.options)
    } else {
      api.reload('312ffe44', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=312ffe44&scoped=true&", function () {
      api.rerender('312ffe44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2E9x1B5henl52/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports